import { useState } from "react";
import "./Home.css";
import "./Marketing.css";
import { SiteNav, SiteFooter, useSeo } from "./_site";

const SUPPORT = "support@helloremy.ai";

const UserIcon = (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
  </svg>
);
const MailIcon = (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2" /><path d="m22 7-10 6L2 7" />
  </svg>
);

export default function Contact() {
  useSeo(
    "Contact Remy | Hello Remy",
    "Get in touch with the Remy team — questions, feedback, or press. We'd love to hear from you."
  );
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Message from ${name || "a Remy visitor"}`);
    const body = encodeURIComponent(`${message}\n\n— ${name}\n${email}`);
    window.location.href = `mailto:${SUPPORT}?subject=${subject}&body=${body}`;
  };

  return (
    <div className="remy-home" data-testid="contact-page">
      <SiteNav />

      <header className="mk-phero" id="top">
        <div className="rh-wrap mk-phero__grid">
          <div className="rh-hero__copy mk-hero-copy">
            <p className="rh-eyebrow">Contact</p>
            <h1 className="rh-hdtext" data-testid="contact-heading">Say hello.</h1>
            <p className="rh-subhead rh-subhead--sm">We'd love to hear from you.</p>
            <p className="rh-body">
              Questions, feedback, or press — send us a note and we'll get back to you.
            </p>
            <p className="mk-contact-email">
              Prefer email? <a href={`mailto:${SUPPORT}`} data-testid="contact-email-link">{SUPPORT}</a>
            </p>
          </div>

          <form className="rh-form rh-form--card" onSubmit={submit} data-testid="contact-form" noValidate>
            <label className="rh-input rh-input--mb" htmlFor="c-name">
              {UserIcon}
              <input id="c-name" name="name" autoComplete="name" placeholder="Your name"
                value={name} onChange={(e) => setName(e.target.value)} required data-testid="contact-name" />
            </label>
            <label className="rh-input rh-input--mb" htmlFor="c-email">
              {MailIcon}
              <input id="c-email" name="email" type="email" autoComplete="email" placeholder="Your email"
                value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="contact-email" />
            </label>
            <textarea className="rh-ta" id="c-message" name="message" placeholder="How can we help?"
              value={message} onChange={(e) => setMessage(e.target.value)} required data-testid="contact-message" />
            <button type="submit" className="rh-btn rh-btn--block" data-testid="contact-submit">
              Send message <span aria-hidden>→</span>
            </button>
            <p className="rh-consent rh-consent--center">This opens your email app to send to {SUPPORT}.</p>
          </form>
        </div>
      </header>

      <SiteFooter />
    </div>
  );
}
